import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';

class ConfirmacaoPedido extends Component {
  state = {
    nomePacienteFiltro: '',
  };

  componentDidMount() {
    localStorage.removeItem('convenio');
    localStorage.removeItem('peso');
    localStorage.removeItem('completed');
    localStorage.removeItem('paciente');
    localStorage.removeItem('dadosSolicitacao');
    localStorage.setItem('activeStep', '0');
  }

  render() {
    return (
      <>
        <Typography variant="h5" gutterBottom>
          Thank you for your order.
        </Typography>
        <Typography variant="subtitle1">
          Your order number is #2001539. We have emailed your order confirmation, and will
          send you an update when your order has shipped.
        </Typography>
      </>
    );
  }
}

export default ConfirmacaoPedido;
